<div class="modal-header w-100 mb-3">
  <div class="modal-title">
    <span class="title-lg">Select a port</span>
    <h6 class="title-desc text-start">
      Please select a port inorder to show available products in this area.
    </h6>
  </div>
  <i class="close btn-close" (click)="onNoClick()"></i>
</div>
<div mat-dialog-content>
  <img src="../../../../assets/Images/select-port.png" class="bg" />
  <form [formGroup]="selectedPortForm" (submit)="onSubmit()" autocomplete="off">
    <div class="row">
      <div class="col-md-12">
        <div class="w-100 input-field">
          <mat-label class="input-label-dark"> Select Country* </mat-label>
          <mat-form-field appearance="outline">
            <mat-label>Select your country...</mat-label>
            <mat-select
              (selectionChange)="getPort($event)"
              formControlName="countryId"
            >
              <mat-option
                *ngFor="let country of data.countries"
                [value]="country.id"
              >
                {{ country.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                selectedPortForm.controls['countryId'].hasError('required')
              "
            >
              This field is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-md-12">
        <div class="w-100 input-field">
          <mat-label class="input-label-dark"> Select Port* </mat-label>
          <mat-form-field appearance="outline">
            <mat-label>Select your port...</mat-label>
            <mat-select formControlName="portId">
              <mat-option *ngFor="let port of ports" [value]="port.id">
                {{ port.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="selectedPortForm.controls['portId'].hasError('required')"
            >
              This field is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div mat-dialog-actions class="float-end modal-footer w-100">
      <button class="btn btn-secondary m-2" (click)="onNoClick()" type="button">
        Cancel
      </button>
      <button type="submit" class="btn btn-primary float-end m-2">
        Save Changes
      </button>
    </div>
  </form>
</div>
